import { render, staticRenderFns } from "./Mechanics.vue?vue&type=template&id=10f17ae6&scoped=true&"
var script = {}
import style0 from "./Mechanics.vue?vue&type=style&index=0&id=10f17ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f17ae6",
  null
  
)

export default component.exports